/**
 * pro-circle.js — Petra Aroma Root Circle customer-facing page
 */

const ProCircle = (() => {
  const cfg = window.__PC_CONFIG__ || {};
  const API_BASE = (cfg.apiBase || '').replace(/\/$/, '');
  const CUSTOMER_EMAIL = cfg.customerEmail;
  const TIER_ICONS = cfg.tierIcons || {};

  let _member = null;
  let _config = null;

  // ── Earn item SVG icons ─────────────────────────────────────────────────────

  const ICONS = {
    bottle: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><rect x="9.5" y="2" width="5" height="2.5" rx="0.3"/><path d="M8.5 4.5h7"/><path d="M9 7l-.4.6a2 2 0 0 0-.6 1.4V19a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V9a2 2 0 0 0-.6-1.4L15 7"/><path d="M12 12c-.7 1-1.2 1.9-1.2 2.7a1.2 1.2 0 0 0 2.4 0c0-.8-.5-1.7-1.2-2.7z"/></svg>`,
    one: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9.5"/><path d="M10.5 9L12.5 7.5v9"/><path d="M10 16.5h5"/></svg>`,
    leaves: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M8 21C7 15 9 10 13 7c-1 6-2.5 11-5 14z"/><path d="M16 21c1-6-1-11-5-14 1 6 2.5 11 5 14z"/><path d="M11.5 14h1"/></svg>`,
    three: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><circle cx="5.5" cy="12" r="2.8"/><circle cx="12" cy="12" r="2.8"/><circle cx="18.5" cy="12" r="2.8"/></svg>`,
    cycle: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M20.5 12a8.5 8.5 0 1 1-2.7-6.2"/><path d="M20.5 3.5v4.5h-4.5"/><path d="M12 12c-.6.8-1 1.5-1 2.2a1 1 0 0 0 2 0c0-.7-.4-1.4-1-2.2z"/></svg>`,
    bottleCycle: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><rect x="10" y="7" width="4" height="2" rx="0.3"/><path d="M9.5 11a2 2 0 0 0-.5 1.3V19a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-6.7a2 2 0 0 0-.5-1.3L14 9.5h-4l-.5 1.5z"/><path d="M5 7a3 3 0 0 1 2-2.8M19 17a3 3 0 0 1-2 2.8"/><path d="M5 7l-.5-1.6L6.2 5M19 17l.5 1.6L17.8 19"/></svg>`,
    star: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 3 14.4 9 20.8 9.5 15.9 14 17.4 20.5 12 17 6.6 20.5 8.1 14 3.2 9.5 9.6 9"/></svg>`,
    envelope: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="18" height="13" rx="1"/><path d="M3.5 7l8.5 6 8.5-6"/></svg>`,
    phone: `<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><rect x="6.5" y="2.5" width="11" height="19" rx="2"/><path d="M11 18.5h2"/><path d="M9 5h6"/></svg>`
  };

  const SHOP_URL = cfg.shopUrl || '/collections/all';
  const REVIEW_URL = cfg.reviewUrl || '#';
  const CUSTOMER_PHONE = cfg.customerPhone || '';
  // Mirror of REDEMPTION_TIERS in src/routes/loyalty.js. Server re-validates
  // every redeem; this is just for display + client-side gating.
  const REDEMPTION_TIERS = [
    { pts: 200,  dollars: 10, minOrder: 0 },
    { pts: 400,  dollars: 20, minOrder: 75 },
    { pts: 800,  dollars: 40, minOrder: 100 },
    { pts: 1600, dollars: 80, minOrder: 250 }
  ];

  // ── Init ────────────────────────────────────────────────────────────────────

  async function init() {
    if (!API_BASE || API_BASE.includes('your-app.onrender.com')) {
      _config = defaultConfig();
      renderTiers();
      renderEarnGrid();
      renderRedeemInfo();
      renderRedeemTickets();
      if (CUSTOMER_EMAIL) { hide('pc-loading'); show('pc-not-member'); }
      return;
    }

    try {
      const email = CUSTOMER_EMAIL || 'config@petra.local';
      const data = await fetch(`${API_BASE}/api/loyalty-public/${encodeURIComponent(email)}`)
        .then(r => r.json());

      _config = data.config || defaultConfig();
      _member = data.member || null;

      renderTiers();
      renderEarnGrid();
      renderRedeemInfo();
      renderRedeemTickets();
    } catch (e) {
      console.warn('[Root Circle] Could not load program config:', e.message);
      _config = defaultConfig();
      renderTiers();
      renderEarnGrid();
      renderRedeemInfo();
      renderRedeemTickets();
    }

    if (CUSTOMER_EMAIL) {
      renderMemberStatus();
    }
  }

  function defaultConfig() {
    return {
      tiers: [
        { name: 'Seed', emoji: '', min_spend: 0, perks: 'Member pricing, sample access' },
        { name: 'Bloom', emoji: '', min_spend: 150, perks: 'Free shipping on orders $80+, 5% loyalty discount' },
        { name: 'Root', emoji: '', min_spend: 400, perks: 'Always free shipping, 10% discount, free 1oz birthday bottle, early access' }
      ],
      earning_rules: { per_dollar: 1, first_order: 25, email_signup: 40, sms_signup: 30, review: 30, subscription_start: 50, subscription_order: 15, referral: 100 },
      redemption_rate: '10',
      redemption_value: '1.00',
      min_redemption_pts: '100',
      free_bottle_pts: '200'
    };
  }

  // ── Member Status ───────────────────────────────────────────────────────────

  function renderMemberStatus() {
    hide('pc-loading');

    if (!_member) {
      show('pc-not-member');
      hide('pc-member-status');
      hide('pc-referral-banner');
      renderRedeemTickets();
      return;
    }

    const m = _member;
    const tierName = (m.loyalty_tier || 'seed').toLowerCase();
    const tierInfo = m.current_tier || {};
    const nextTier = m.next_tier || null;

    // Heading: Hi [name], you have X Points
    set('pc-first-name', m.first_name || 'there');
    set('pc-points', Number(m.loyalty_points || 0).toLocaleString());

    // Points expiry pill
    if (m.points_expires_at && Number(m.loyalty_points || 0) > 0) {
      const expD = new Date(m.points_expires_at);
      if (!isNaN(expD.getTime())) {
        set('pc-points-expiry-date', formatExpiryDate(expD));
        show('pc-points-expiry');
      } else {
        hide('pc-points-expiry');
      }
    } else {
      hide('pc-points-expiry');
    }

    // Tier badge
    const badge = el('pc-tier-badge');
    if (badge) {
      badge.textContent = tierInfo.name || tierName;
      badge.className = `pc-tier-badge ${tierName}`;
    }

    // Progress to next tier
    if (nextTier) {
      const needed = Math.max(0, nextTier.min_spend - (m.annual_spend || 0));
      set('pc-spend-to-next', `$${needed.toFixed(0)}`);
      set('pc-tier-from', `${tierInfo.name || ''}`);
      set('pc-tier-to', `${nextTier.name || ''}`);
      const fill = el('pc-progress-fill');
      if (fill) fill.style.width = `${m.progress_pct || 0}%`;
      show('pc-progress-wrap');
    }

    show('pc-member-status');
    hide('pc-not-member');

    // Activity history
    renderHistory(m.history || []);

    // Referral link
    if (m.referral_code) {
      const link = `https://www.petraaroma.com/pages/pro-access?ref=${m.referral_code}`;
      set('pc-referral-link-text', link);
      set('pc-referral-link-full', link);
      show('pc-referral-banner');
      show('pc-referral-link-block');
      const form = el('pc-referral-form');
      if (form) form.classList.add('pc-hidden');
    }

    // Highlight current tier column in comparison table
    document.querySelectorAll(`.pc-tier-col[data-tier="${tierName}"]`).forEach(col => {
      col.classList.add('active');
    });
    // Show "You are on the X tier" text
    const tierLabel = tierInfo.name || tierName;
    set('pc-current-tier-name', tierLabel);
    show('pc-current-tier-text');

    // Redeem tickets
    renderRedeemTickets();
  }

  // ── Activity history ────────────────────────────────────────────────────────

  const HISTORY_INITIAL = 5;
  const HISTORY_TYPE_LABELS = {
    earn_purchase: 'Purchase',
    earn_subscription: 'Subscription Order',
    earn_referral: 'Referral Bonus',
    earn_review: 'Posted A Product Review',
    earn_bonus_first_order: 'First Order Bonus',
    earn_bonus_three_purchases: 'Three Purchases Bonus',
    earn_bonus_subscription_start: 'Subscription Start Bonus',
    earn_anniversary: 'Anniversary Bonus',
    earn_email_signup: 'Email Signup',
    earn_sms_signup: 'SMS Signup',
    earn_referee_signup: 'Welcome Bonus',
    earn_direct_signup: 'Welcome Bonus',
    redeem: 'Redeemed A Reward',
    adjust: 'Adjustment'
  };

  function labelForTxn(txn) {
    if (txn.type === 'adjust' && Number(txn.points) > 0 && /refund/i.test(txn.notes || '')) {
      return 'Points Refunded';
    }
    return HISTORY_TYPE_LABELS[txn.type] || (txn.notes || 'Activity');
  }

  function formatExpiryDate(d) {
    const day = d.getDate();
    const suffix = (day >= 11 && day <= 13) ? 'th'
      : day % 10 === 1 ? 'st'
      : day % 10 === 2 ? 'nd'
      : day % 10 === 3 ? 'rd' : 'th';
    const month = d.toLocaleDateString('en-US', { month: 'short' });
    return `${day}${suffix} ${month} ${d.getFullYear()}`;
  }

  function formatTxnDate(iso) {
    try {
      const d = new Date(iso);
      if (isNaN(d.getTime())) return '';
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    } catch (e) { return ''; }
  }

  function renderHistory(rows) {
    const wrap = el('pc-history-wrap');
    const tbody = el('pc-history-rows');
    const moreBtn = el('pc-history-more');
    if (!wrap || !tbody) return;

    if (!rows.length) {
      tbody.innerHTML = '<div class="pc-history-empty">No activity yet. Place an order or share your referral link to start earning.</div>';
      if (moreBtn) moreBtn.classList.add('pc-hidden');
      wrap.classList.remove('pc-hidden');
      return;
    }

    function rowHtml(r) {
      const pts = Number(r.points) || 0;
      const sign = pts > 0 ? '+ ' : pts < 0 ? '− ' : '';
      const cls = pts > 0 ? 'is-earn' : 'is-redeem';
      let codeHtml = '';
      if (r.discount_code) {
        const active = r.discount_code_active;
        const expLabel = r.discount_code_expires_at
          ? `Expires ${formatTxnDate(r.discount_code_expires_at)}`
          : '';
        codeHtml = `
          <div class="pc-history-code ${active ? 'is-active' : 'is-expired'}" role="cell">
            <span class="pc-history-code-value">${escapeHtml(r.discount_code)}</span>
            <button type="button" class="pc-history-code-copy" data-code="${escapeHtml(r.discount_code)}" aria-label="Copy code">Copy</button>
            ${expLabel ? `<span class="pc-history-code-exp">${active ? expLabel : 'Expired'}</span>` : ''}
          </div>`;
      }
      return `
        <div class="pc-history-row${codeHtml ? ' has-code' : ''}" role="row">
          <div class="pc-history-activity" role="cell">${escapeHtml(labelForTxn(r))}</div>
          <div class="pc-history-points ${cls}" role="cell">${sign}${Math.abs(pts).toLocaleString()} Points</div>
          <div class="pc-history-date" role="cell">${formatTxnDate(r.created_at)}</div>
          ${codeHtml}
        </div>`;
    }

    let expanded = false;
    function render() {
      const visible = expanded ? rows : rows.slice(0, HISTORY_INITIAL);
      tbody.innerHTML = visible.map(rowHtml).join('');
      if (moreBtn) {
        if (rows.length > HISTORY_INITIAL && !expanded) {
          moreBtn.textContent = 'Show more';
          moreBtn.classList.remove('pc-hidden');
        } else {
          moreBtn.classList.add('pc-hidden');
        }
      }
    }
    render();
    if (!tbody.dataset.copyBound) {
      tbody.dataset.copyBound = '1';
      tbody.addEventListener('click', (ev) => {
        const btn = ev.target.closest('.pc-history-code-copy');
        if (!btn) return;
        const code = btn.dataset.code || '';
        if (!code) return;
        const done = () => {
          const prev = btn.textContent;
          btn.textContent = 'Copied!';
          btn.classList.add('is-copied');
          setTimeout(() => { btn.textContent = prev; btn.classList.remove('is-copied'); }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          const ta = document.createElement('textarea');
          ta.value = code; document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          done();
        }
      });
    }
    if (moreBtn && !moreBtn.dataset.bound) {
      moreBtn.dataset.bound = '1';
      moreBtn.addEventListener('click', () => { expanded = true; render(); });
    }
    wrap.classList.remove('pc-hidden');
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  // ── Static sections ─────────────────────────────────────────────────────────

  function renderTiers() {
    const tiers = _config?.tiers || [];
    const container = el('pc-tiers-grid');
    if (!container || tiers.length === 0) return;

    container.innerHTML = tiers.map(t => {
      const tierKey = t.name.toLowerCase();
      const perks = (t.perks || '').split(',').map(s => s.trim()).filter(Boolean);
      const iconUrl = TIER_ICONS[tierKey];
      const iconHtml = iconUrl
        ? `<img src="${iconUrl}" alt="${t.name}" class="pc-tier-icon-img">`
        : `<div class="pc-tier-icon-default"></div>`;

      return `
        <div class="pc-tier-card" data-tier="${tierKey}">
          ${iconHtml}
          <div class="pc-tier-info">
            <div class="pc-tier-name">${t.name}</div>
            <div class="pc-tier-threshold">${t.min_spend > 0 ? '$' + t.min_spend + '+/year' : 'All members'}</div>
            <ul class="pc-tier-perks">${perks.map(p => `<li>${p}</li>`).join('')}</ul>
          </div>
        </div>`;
    }).join('');

    // Re-highlight if member already rendered
    if (_member) {
      const tierName = (_member.loyalty_tier || 'seed').toLowerCase();
      document.querySelectorAll('.pc-tier-card').forEach(card => {
        if (card.dataset.tier === tierName && !card.querySelector('.pc-tier-current-badge')) {
          card.classList.add('active');
          const b = document.createElement('div');
          b.className = 'pc-tier-current-badge';
          b.textContent = 'Your current tier';
          card.querySelector('.pc-tier-info').appendChild(b);
        }
      });
    }
  }

  function renderReviewProducts() {
    const products = _member?.purchased_products || [];
    if (!_member) return `<p>Sign in to see your purchased products.</p>`;
    if (products.length === 0) return `<p>Place an order first, then come back to leave a review and earn points.</p>`;

    const unreviewed = products.filter(p => !p.reviewed);
    const reviewed = products.filter(p => p.reviewed);

    let html = '';
    if (unreviewed.length > 0) {
      html += `<p><strong>Choose a product to review:</strong></p>`;
      html += unreviewed.map(p => {
        const url = p.handle ? `/products/${p.handle}#judgeme_product_reviews` : REVIEW_URL;
        return `<a href="${url}" style="display:block;padding:8px 0;color:#3d2c1e;text-decoration:none;border-bottom:1px solid rgba(0,0,0,0.08)" onmouseover="this.style.opacity='0.7'" onmouseout="this.style.opacity='1'">${escapeHtml(p.title)} <span style="opacity:0.5">→</span></a>`;
      }).join('');
    } else {
      html += `<p><strong>You've reviewed every product you've ordered. Thank you!</strong></p>`;
    }

    if (reviewed.length > 0) {
      html += `<p style="margin-top:14px;margin-bottom:4px;font-size:0.9rem;opacity:0.7"><strong>Already reviewed</strong></p>`;
      html += reviewed.map(p => {
        return `<div style="display:flex;justify-content:space-between;align-items:center;padding:8px 0;color:#3d2c1e;opacity:0.55;border-bottom:1px solid rgba(0,0,0,0.08);cursor:default" aria-disabled="true"><span>${escapeHtml(p.title)}</span><span style="font-size:0.85rem;color:#4a7c59;font-weight:600">Reviewed ✓</span></div>`;
      }).join('');
    }
    return html;
  }

  function renderEarnGrid() {
    const rules = _config?.earning_rules || {};
    const container = el('pc-earn-grid');
    if (!container) return;

    const emailEarned = !!(_member && _member.earned_email_signup);
    const smsEarned = !!(_member && _member.earned_sms_signup);
    const firstOrderEarned = !!(_member && _member.earned_first_order);

    const items = [
      { icon: ICONS.bottle, pts: `+${rules.per_dollar || 1} pt per $1`, label: 'Place an order', action: { type: 'link', url: SHOP_URL } },
      firstOrderEarned
        ? { icon: ICONS.one, pts: 'Earned', label: 'First order bonus claimed', earned: true }
        : { icon: ICONS.one, pts: `+${rules.first_order || 25} pts`, label: 'First order bonus', action: { type: 'link', url: SHOP_URL } },
      { icon: ICONS.leaves, pts: `+${rules.referral || 100} pts`, label: 'Refer a colleague', action: { type: 'scroll', target: '#pc-refer' } },
      { icon: ICONS.cycle, pts: `+${rules.subscription_start || 50} pts`, label: 'Start a subscription (8 oz)', action: { type: 'link', url: SHOP_URL } },
      { icon: ICONS.bottleCycle, pts: `+${rules.subscription_order || 5} pts`, label: 'Subscription orders', action: { type: 'detail', text: `Earn <strong>${rules.subscription_order || 5} bonus points</strong> on every recurring subscription order, on top of your regular per-dollar points. Subscriptions are available on 8 oz bottles.` } },
      { icon: ICONS.star, pts: `+${rules.review || 20} pts`, label: 'Post a review', action: { type: 'detail', text: renderReviewProducts() } },
      emailEarned
        ? { icon: ICONS.envelope, pts: 'Earned', label: 'Joined our email list', earned: true }
        : { icon: ICONS.envelope, pts: `+${rules.email_signup || 10} pts`, label: 'Join our email list', action: { type: 'form', form: 'email' } },
      smsEarned
        ? { icon: ICONS.phone, pts: 'Earned', label: 'Joined our SMS list', earned: true }
        : { icon: ICONS.phone, pts: `+${rules.sms_signup || 25} pts`, label: 'Join our SMS list', action: { type: 'form', form: 'sms' } },
    ];

    function clickHandler(action, i) {
      if (!action) return '';
      if (action.type === 'link') return `onclick="window.location.href='${action.url}'"`;
      if (action.type === 'scroll') return `onclick="ProCircle._scrollTo('${action.target}')"`;
      return `onclick="ProCircle._toggleEarn(${i})"`;
    }

    container.innerHTML = items.map((item, i) => {
      const classes = ['pc-earn-item'];
      if (!item.action) classes.push('pc-earn-item-noclick');
      if (item.earned) classes.push('pc-earn-item-earned');
      return `
      <div class="${classes.join(' ')}" data-index="${i}" ${clickHandler(item.action, i)}${item.earned ? ' aria-disabled="true"' : ''}>
        ${item.icon}
        <div class="pc-earn-label">${item.label}</div>
        <div class="pc-earn-pts">${item.pts}</div>
        ${item.earned ? '<span class="pc-earn-check" aria-hidden="true">✓</span>' : (item.action ? '<span class="pc-earn-arrow">&#8594;</span>' : '')}
      </div>`;
    }).join('') +
      items.map((item, i) => {
        if (!item.action || (item.action.type !== 'detail' && item.action.type !== 'form')) return '';
        let body = '';
        if (item.action.type === 'detail') {
          body = item.action.text;
        } else if (item.action.form === 'email') {
          body = renderEmailForm();
        } else if (item.action.form === 'sms') {
          body = renderSmsForm();
        }
        return `<div class="pc-earn-detail" id="pc-earn-detail-${i}">${body}</div>`;
      }).join('');
  }

  function renderEmailForm() {
    if (!CUSTOMER_EMAIL) {
      return `<p>Sign in to subscribe and earn points. <a href="/account/login?return_url=/pages/pro-circle">Sign in</a></p>`;
    }
    return `
      <div class="pc-signup-form">
        <div class="pc-signup-field">${CUSTOMER_EMAIL}</div>
        <p class="pc-signup-text">Subscribe to our email list and earn points</p>
        <button class="pc-btn pc-btn-dark" onclick="ProCircle._subscribeEmail()" id="pc-email-btn">Subscribe</button>
        <div id="pc-email-msg" class="pc-signup-msg"></div>
      </div>`;
  }

  function renderSmsForm() {
    if (!CUSTOMER_EMAIL) {
      return `<p>Sign in to subscribe and earn points. <a href="/account/login?return_url=/pages/pro-circle">Sign in</a></p>`;
    }
    return `
      <div class="pc-signup-form">
        <div style="display:flex;align-items:center;gap:6px;">
          <span style="font-size:15px;font-weight:500;opacity:0.7;">+1</span>
          <input type="tel" class="pc-signup-field pc-signup-input" id="pc-sms-input" placeholder="(555) 555-5555" value="${CUSTOMER_PHONE}" maxlength="14" style="flex:1;"
            oninput="this.value=this.value.replace(/[^0-9]/g,'').replace(/^(\\d{3})(\\d)/,'($1) $2').replace(/(\\d{3})(\\d)/,'$1-$2')">
        </div>
        <p class="pc-signup-text">Subscribe to our SMS list and earn points</p>
        <button class="pc-btn pc-btn-dark" onclick="ProCircle._subscribeSms()" id="pc-sms-btn">Subscribe</button>
        <div id="pc-sms-msg" class="pc-signup-msg"></div>
      </div>`;
  }

  function _toggleEarn(index) {
    const detail = el(`pc-earn-detail-${index}`);
    const card = document.querySelector(`.pc-earn-item[data-index="${index}"]`);
    if (!detail || !card) return;

    const isOpen = detail.classList.contains('visible');

    // Close all
    document.querySelectorAll('.pc-earn-detail').forEach(d => d.classList.remove('visible'));
    document.querySelectorAll('.pc-earn-item').forEach(c => c.classList.remove('active'));

    if (!isOpen) {
      detail.classList.add('visible');
      card.classList.add('active');
      detail.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function _scrollTo(target) {
    const t = document.querySelector(target);
    if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  async function _subscribeEmail() {
    const btn = el('pc-email-btn');
    const msg = el('pc-email-msg');
    if (!CUSTOMER_EMAIL || !btn) return;
    btn.disabled = true;
    btn.textContent = 'Subscribing...';
    try {
      const res = await fetch(`${API_BASE}/api/loyalty-public/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: CUSTOMER_EMAIL, channel: 'email' })
      });
      const data = await res.json();
      if (data.success) {
        btn.textContent = 'Subscribed ✓';
        if (msg) msg.textContent = data.points_awarded
          ? `You're in! +${data.points_awarded} points added. A welcome email is on its way.`
          : 'You are already subscribed.';
        if (_member) _member.earned_email_signup = true;
        // Let the confirmation be read before the grid re-renders to the earned state.
        setTimeout(renderEarnGrid, 3500);
      } else {
        btn.disabled = false;
        btn.textContent = 'Subscribe';
        if (msg) msg.textContent = data.error || 'Could not subscribe. Please try again.';
      }
    } catch (e) {
      btn.disabled = false;
      btn.textContent = 'Subscribe';
      if (msg) msg.textContent = 'Could not connect. Please try again.';
    }
  }

  async function _subscribeSms() {
    const btn = el('pc-sms-btn');
    const msg = el('pc-sms-msg');
    const input = el('pc-sms-input');
    if (!CUSTOMER_EMAIL || !btn || !input) return;
    const digits = input.value.replace(/\D/g, '');
    if (!digits || digits.length !== 10) {
      if (msg) msg.textContent = 'Please enter a valid 10-digit phone number.';
      return;
    }
    const phone = '+1' + digits;
    btn.disabled = true;
    btn.textContent = 'Subscribing...';
    try {
      // Backend subscribes to Klaviyo (server-side, private API key) and awards points.
      const res = await fetch(`${API_BASE}/api/loyalty-public/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: CUSTOMER_EMAIL, channel: 'sms', phone })
      });
      const data = await res.json();
      if (data.success) {
        btn.textContent = 'Subscribed ✓';
        if (msg) msg.textContent = data.points_awarded
          ? `You're in! +${data.points_awarded} points added. Check your phone for a confirmation text.`
          : 'You are already subscribed.';
        if (_member) _member.earned_sms_signup = true;
        setTimeout(renderEarnGrid, 3500);
      } else {
        btn.disabled = false;
        btn.textContent = 'Subscribe';
        if (msg) msg.textContent = data.error || 'Subscribed to SMS, but could not award points. Please refresh.';
      }
    } catch (e) {
      btn.disabled = false;
      btn.textContent = 'Subscribe';
      if (msg) msg.textContent = 'Could not connect. Please try again.';
    }
  }

  function renderRedeemInfo() {
    /* fine-print is now fully editable via theme settings — nothing to inject */
  }

  // ── Redeem Tickets ──────────────────────────────────────────────────────────

  function ptsToDollars(pts) {
    const rate = Number(_config?.redemption_rate) || 10;
    const rawVal = _config?.redemption_value;
    const val = (rawVal !== undefined && rawVal !== null && rawVal !== '') ? Number(rawVal) : 1.00;
    return (pts / rate) * val;
  }

  // 5-petal flower: filled circles arranged around a center form a clean flower outline.
  // Outer circles (border color) + slightly smaller inner circles (fill color) = a crisp
  // ring around the entire flower with no visible seams between petals.
  const FLOWER_SVG = `
    <svg class="pc-flower-svg" viewBox="0 0 220 220" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g class="pc-flower-border">
        <circle cx="110" cy="58" r="61"/>
        <circle cx="60" cy="94" r="61"/>
        <circle cx="79" cy="152" r="61"/>
        <circle cx="141" cy="152" r="61"/>
        <circle cx="160" cy="94" r="61"/>
      </g>
      <g class="pc-flower-fill">
        <circle cx="110" cy="58" r="58"/>
        <circle cx="60" cy="94" r="58"/>
        <circle cx="79" cy="152" r="58"/>
        <circle cx="141" cy="152" r="58"/>
        <circle cx="160" cy="94" r="58"/>
      </g>
    </svg>`;

  function renderRedeemTickets() {
    const container = el('pc-ticket-grid');
    if (!container) return;
    const memberPts = Number(_member?.loyalty_points || 0);
    const isMember = !!_member;

    container.innerHTML = REDEMPTION_TIERS.map(tier => {
      const dollarStr = `$${tier.dollars}`;
      const locked = isMember && memberPts < tier.pts;
      const cls = locked ? 'pc-ticket pc-ticket-locked' : 'pc-ticket';
      const minLine = tier.minOrder > 0
        ? `Orders over $${tier.minOrder}`
        : 'No minimum';
      const onclick = `onclick="ProCircle.requestRedeem(${tier.pts})"`;
      return `
        <button type="button" class="${cls}" ${onclick} ${locked ? 'disabled' : ''} aria-label="Redeem ${tier.pts} points for ${dollarStr} off">
          <div class="pc-ticket-shape">
            ${FLOWER_SVG}
            <div class="pc-ticket-amount">${dollarStr}</div>
          </div>
          <div class="pc-ticket-pts">${tier.pts} pts</div>
          <div class="pc-ticket-min">${minLine}</div>
        </button>`;
    }).join('');
  }

  function showRedeemModal({ tier, dollarStr, onConfirm }) {
    const minLine = tier.minOrder > 0
      ? `Applies to all orders over $${tier.minOrder}.00.`
      : 'No minimum order, applies to any purchase.';
    const overlay = document.createElement('div');
    overlay.className = 'pc-modal-overlay';
    overlay.innerHTML = `
      <div class="pc-modal" role="dialog" aria-modal="true" aria-label="Confirm redemption">
        <button type="button" class="pc-modal-close" aria-label="Close">&times;</button>
        <div class="pc-modal-ticket">
          <div class="pc-ticket-shape">
            ${FLOWER_SVG}
            <div class="pc-ticket-amount">${dollarStr}</div>
          </div>
        </div>
        <div class="pc-modal-title">${dollarStr} Off</div>
        <div class="pc-modal-pts">${tier.pts} Points</div>
        <p class="pc-modal-min">${minLine}</p>
        <div class="pc-modal-actions">
          <button type="button" class="pc-btn pc-modal-cancel">Cancel</button>
          <button type="button" class="pc-btn pc-modal-redeem">Redeem</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    const close = () => { overlay.remove(); document.body.style.overflow = ''; };
    overlay.querySelector('.pc-modal-close').addEventListener('click', close);
    overlay.querySelector('.pc-modal-cancel').addEventListener('click', close);
    overlay.addEventListener('click', e => { if (e.target === overlay) close(); });
    overlay.querySelector('.pc-modal-redeem').addEventListener('click', () => { close(); onConfirm(); });
  }

  async function requestRedeem(pts) {
    pts = Number(pts) || 0;
    if (pts <= 0) return;
    const result = el('pc-redeem-result');
    if (!_member) {
      if (result) {
        result.classList.remove('pc-hidden');
        result.innerHTML = `<strong>Sign in to redeem.</strong><br>Once you're logged in as a professional member, tap a ticket to request your code.`;
      }
      return;
    }
    const memberPts = Number(_member.loyalty_points || 0);
    if (memberPts < pts) {
      if (result) {
        result.classList.remove('pc-hidden');
        result.innerHTML = `<strong>You need ${pts - memberPts} more pts.</strong><br>You currently have ${memberPts} pts. Keep earning to unlock this reward.`;
      }
      return;
    }
    const tier = REDEMPTION_TIERS.find(t => t.pts === pts);
    if (!tier) return;
    const dollarStr = `$${tier.dollars}`;

    showRedeemModal({ tier, dollarStr, onConfirm: () => doRedeem(pts, dollarStr) });
  }

  async function doRedeem(pts, dollarStr) {
    const result = el('pc-redeem-result');
    if (result) {
      result.classList.remove('pc-hidden');
      result.innerHTML = `<strong>Generating your code...</strong>`;
    }

    try {
      // Through the App Proxy: Shopify signs the request and names the
      // signed-in customer, so nobody can redeem another member's points by
      // typing their email (the old public endpoint allowed exactly that).
      const res = await fetch('/apps/petra/pro/redeem', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ points: pts })
      });
      const data = await res.json();

      if (!res.ok || !data.success) {
        throw new Error(data.error || 'Something went wrong');
      }

      // Update local member points
      _member.loyalty_points = data.new_total;
      renderMemberStatus();

      if (result) {
        result.innerHTML = `
          <strong>Your discount code is ready!</strong><br>
          <span style="display:inline-block;margin:10px 0;padding:10px 20px;background:#3d2c1e;color:#f9f8ec;border-radius:4px;font-size:18px;letter-spacing:0.08em;font-weight:600;cursor:pointer;"
            onclick="navigator.clipboard.writeText('${data.code}').then(()=>{this.textContent='Copied!';setTimeout(()=>{this.textContent='${data.code}'},2000)})"
            title="Click to copy">${data.code}</span>
          <br><strong>$${data.discount_amount} off</strong> your next order. Expires ${data.expires_at}.<br>
          <small>Click the code to copy it, then use it at checkout.</small>`;
      }
    } catch (err) {
      if (result) {
        result.innerHTML = `<strong>Could not generate code.</strong><br>${err.message}`;
      }
    }

    if (result && result.scrollIntoView) result.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // ── Referral ────────────────────────────────────────────────────────────────

  function copyReferralLink() {
    const linkText = el('pc-referral-link-text')?.textContent || el('pc-referral-link-full')?.textContent;
    if (!linkText || linkText === '--') return;
    navigator.clipboard.writeText(linkText).then(() => {
      document.querySelectorAll('[onclick="ProCircle.copyReferralLink()"]').forEach(btn => {
        const orig = btn.textContent;
        btn.textContent = 'Copied!';
        setTimeout(() => { btn.textContent = orig; }, 2000);
      });
    });
  }

  async function _submitReferralForm(e) {
    if (e && e.preventDefault) e.preventDefault();
    const nameEl = el('pc-ref-name');
    const emailEl = el('pc-ref-email');
    const optinEl = el('pc-ref-optin');
    const btn = el('pc-ref-submit');
    const errEl = el('pc-ref-error');

    if (!nameEl || !emailEl || !btn) return false;
    const name = nameEl.value.trim();
    const email = emailEl.value.trim();
    if (!name || !email || !email.includes('@')) {
      if (errEl) { errEl.textContent = 'Please enter your name and a valid email.'; errEl.classList.remove('pc-hidden'); }
      return false;
    }
    if (errEl) errEl.classList.add('pc-hidden');

    btn.disabled = true;
    const origLabel = btn.textContent;
    btn.textContent = 'Creating your link...';

    try {
      const res = await fetch(`${API_BASE}/api/loyalty-public/referral-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          email,
          email_optin: optinEl ? !!optinEl.checked : false
        })
      });
      const data = await res.json();
      if (!res.ok || !data.referral_url) {
        btn.disabled = false;
        btn.textContent = origLabel;
        if (errEl) { errEl.textContent = data.error || 'Could not create your link. Please try again.'; errEl.classList.remove('pc-hidden'); }
        return false;
      }

      const form = el('pc-referral-form');
      if (form) form.classList.add('pc-hidden');
      set('pc-referral-link-full', data.referral_url);
      show('pc-referral-link-block');
    } catch (err) {
      btn.disabled = false;
      btn.textContent = origLabel;
      if (errEl) { errEl.textContent = 'Could not connect. Please try again.'; errEl.classList.remove('pc-hidden'); }
    }
    return false;
  }

  function checkReferralParam() {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');
    if (ref) {
      sessionStorage.setItem('petra_referral', ref);
      _activateRefereeMode(ref);
    } else {
      const stored = sessionStorage.getItem('petra_referral');
      if (stored) _activateRefereeMode(stored);
    }
  }

  function _activateRefereeMode(refCode) {
    // Switch referral section to "claim" mode for the referee
    const refSection = el('pc-refer');
    if (!refSection) return;
    let form = el('pc-referral-form');
    if (!form) {
      // Signed-out (or non-pro) referee: Liquid rendered the "Pros only" gate
      // instead of the form. Replace the gate with a claim form.
      const gated = refSection.querySelector('.pc-referral-gated');
      if (!gated) return;
      const pick = (style) => (style || '').split(';')
        .filter(s => /^\s*(background|color)\s*:/.test(s)).join(';');
      const inputStyle = pick(gated.getAttribute('style'));
      const btnStyle = gated.querySelector('a.pc-btn')?.getAttribute('style') || '';
      const holder = document.createElement('div');
      holder.innerHTML = `
        <form id="pc-referral-form" class="pc-referral-form" onsubmit="return ProCircle._submitReferralClaim(event)">
          <input type="text" id="pc-ref-name" class="pc-form-input" placeholder="Your Name" required style="${inputStyle}">
          <input type="email" id="pc-ref-email" class="pc-form-input" placeholder="Your Email" required style="${inputStyle}">
          <label class="pc-referral-checkbox"><input type="checkbox" id="pc-ref-optin" checked><span>Sign up for Petra Aroma emails.</span></label>
          <button type="submit" class="pc-btn pc-referral-submit" id="pc-ref-submit" style="${btnStyle}">Claim my discount</button>
          <p id="pc-ref-error" class="pc-referral-error pc-hidden"></p>
        </form>
        <div id="pc-referral-link-block" class="pc-hidden"></div>`;
      gated.replaceWith(holder);
      form = el('pc-referral-form');
      if (!form) return;
    }

    // Update form to submit to referral-claim instead of referral-request
    form.setAttribute('onsubmit', 'return ProCircle._submitReferralClaim(event)');
    form.dataset.refCode = refCode;

    // Swap headings if referee-mode elements exist
    const eyebrow = refSection.querySelector('.pc-eyebrow-dark');
    const title = refSection.querySelector('.pc-section-title-left');
    const subtitle = refSection.querySelector('.pc-referral-subtitle');
    const refEyebrow = el('pc-referee-eyebrow');
    const refTitle = el('pc-referee-title');
    const refSubtitle = el('pc-referee-subtitle');

    if (refEyebrow && refEyebrow.textContent.trim() && eyebrow) eyebrow.textContent = refEyebrow.textContent;
    if (refTitle && refTitle.textContent.trim() && title) title.textContent = refTitle.textContent;
    if (refSubtitle && refSubtitle.textContent.trim() && subtitle) subtitle.textContent = refSubtitle.textContent;

    // Change submit button text
    const btn = el('pc-ref-submit');
    const claimLabel = el('pc-referee-btn-label');
    if (btn && claimLabel && claimLabel.textContent.trim()) btn.textContent = claimLabel.textContent;
  }

  async function _submitReferralClaim(e) {
    if (e && e.preventDefault) e.preventDefault();
    const nameEl = el('pc-ref-name');
    const emailEl = el('pc-ref-email');
    const optinEl = el('pc-ref-optin');
    const btn = el('pc-ref-submit');
    const errEl = el('pc-ref-error');
    const form = el('pc-referral-form');

    if (!nameEl || !emailEl || !btn || !form) return false;
    const name = nameEl.value.trim();
    const email = emailEl.value.trim();
    const refCode = form.dataset.refCode;

    if (!name || !email || !email.includes('@')) {
      if (errEl) { errEl.textContent = 'Please enter your name and a valid email.'; errEl.classList.remove('pc-hidden'); }
      return false;
    }
    if (errEl) errEl.classList.add('pc-hidden');

    btn.disabled = true;
    const origLabel = btn.textContent;
    btn.textContent = 'Claiming your discount...';

    try {
      const res = await fetch(`${API_BASE}/api/loyalty-public/referral-claim`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          email,
          ref_code: refCode,
          email_optin: optinEl ? !!optinEl.checked : false
        })
      });
      const data = await res.json();
      if (!res.ok || !data.success) {
        btn.disabled = false;
        btn.textContent = origLabel;
        if (errEl) { errEl.textContent = data.error || 'Could not claim. Please try again.'; errEl.classList.remove('pc-hidden'); }
        return false;
      }

      // Hide form, show discount code
      form.classList.add('pc-hidden');
      sessionStorage.removeItem('petra_referral');

      const linkBlock = el('pc-referral-link-block');
      if (linkBlock) {
        const welcomeName = data.referrer_name || 'your colleague';
        const pts = Number(data.points_awarded) || 0;
        const ptsLine = pts > 0
          ? `<p style="margin:8px 0;opacity:0.9"><strong>+${pts} welcome points</strong> have been added to your account. Redeem them for a credit toward your first order.</p>`
          : '';
        let successHTML = '';
        if (data.discount_code) {
          successHTML = `
            <p class="pc-referral-success-title">Welcome! ${welcomeName} sent you here.</p>
            ${ptsLine}
            <p style="margin:8px 0 14px;opacity:0.9">Or use this code for $${data.discount_amount} off your first order of $${data.min_order}+:</p>
            <p class="pc-referral-link-display" style="font-size:1.3rem;font-weight:600;text-align:center;letter-spacing:2px">${data.discount_code}</p>
            <p style="margin-top:12px;font-size:0.85rem;opacity:0.7">Single-use · Expires in 90 days</p>
          `;
        } else {
          successHTML = `
            <p class="pc-referral-success-title">Welcome! You have been referred by ${welcomeName}.</p>
            ${ptsLine}
            <p style="margin:8px 0;opacity:0.9">Place your first order and both of you will earn rewards.</p>
          `;
        }
        linkBlock.innerHTML = successHTML;
        linkBlock.classList.remove('pc-hidden');
      }
    } catch (err) {
      btn.disabled = false;
      btn.textContent = origLabel;
      if (errEl) { errEl.textContent = 'Could not connect. Please try again.'; errEl.classList.remove('pc-hidden'); }
    }
    return false;
  }

  // ── Helpers ─────────────────────────────────────────────────────────────────

  function el(id) { return document.getElementById(id); }
  function set(id, text) { const e = el(id); if (e) e.textContent = text; }
  function show(id) { const e = el(id); if (e) e.classList.remove('pc-hidden'); }
  function hide(id) { const e = el(id); if (e) e.classList.add('pc-hidden'); }

  // ── Boot ────────────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', () => {
    checkReferralParam();
    if (API_BASE) init();
  });

  return { requestRedeem, copyReferralLink, _toggleEarn, _scrollTo, _subscribeEmail, _subscribeSms, _submitReferralForm, _submitReferralClaim };
})();
